import { render } from "./NavLink.vue?vue&type=template&id=493a52f8"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"
script.render = render

export default script